module.exports = __webpack_public_path__ + "img/smiling_face_with_tear_3d.528b3d18.png";